(() => {
  if (customElements.get('search-form')) return;

  class WubPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.drawer = this.closest('#Search-Drawer') || document.getElementById('Search-Drawer');
      this.results = this.drawer?.querySelector('[data-wub-predictive-results-container]');
      this.predictiveUrl = this.dataset.predictiveSearchUrl || '/search/suggest';
      this.searchError = this.dataset.searchError || '';
      this.timer = null;
      this.controller = null;

      if (!this.form || !this.input) return;

      this.form.addEventListener('submit', event => {
        if (!this.input.value.trim()) event.preventDefault();
      });

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.update(), 180);
      });

      this.input.addEventListener('focus', () => {
        if (this.input.value.trim() && this.results && !this.results.hasChildNodes()) this.update();
      });
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    async update() {
      const term = this.input.value.trim();
      if (!this.results) return;

      if (!term) {
        this.results.innerHTML = '';
        this.results.setAttribute('aria-busy', 'false');
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.results.setAttribute('aria-busy', 'true');
      this.results.classList.add('is-loading');

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,article,query,page',
        'resources[limit]': '8',
        'resources[options][fields]': 'title,product_type,vendor,variants.title,variants.sku',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(`${this.predictiveUrl}?${params.toString()}`, {
          signal: this.controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('[data-wub-predictive-results]');
        this.results.innerHTML = incoming ? incoming.outerHTML : '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          const message = document.createElement('p');
          message.className = 'wub-predictive-search__error';
          message.textContent = this.searchError;
          this.results.replaceChildren(message);
        }
      } finally {
        this.results.classList.remove('is-loading');
        this.results.setAttribute('aria-busy', 'false');
      }
    }
  }

  customElements.define('search-form', WubPredictiveSearch);
})();
